import { Geolocation } from '@capacitor/geolocation';
import { Capacitor } from '@capacitor/core';

/**
 * Unified geolocation service that works on web and Capacitor native apps
 */
export const getUnifiedCurrentPosition = async () => {
  const isNative = Capacitor.isNativePlatform();
  
  if (isNative) {
    // Use Capacitor Geolocation plugin for native apps
    try {
      const position = await Geolocation.getCurrentPosition({
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      });
      
      return {
        coords: {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          accuracy: position.coords.accuracy
        },
        timestamp: position.timestamp
      };
    } catch (error) {
      console.error('Capacitor Geolocation error:', error);
      throw error;
    }
  } else {
    // Use web browser Geolocation API
    return new Promise((resolve, reject) => {
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(
          (position) => resolve(position),
          (error) => reject(error),
          {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 0
          }
        );
      } else {
        reject(new Error('Geolocation not supported'));
      }
    });
  }
};

/**
 * Watch position changes (for real-time tracking)
 */
export const watchUnifiedPosition = async (callback) => {
  const isNative = Capacitor.isNativePlatform();
  
  if (isNative) {
    const watchId = await Geolocation.watchPosition(
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      },
      (position, error) => {
        if (error) {
          console.error('Watch position error:', error);
          return;
        }
        callback(position);
      }
    );
    
    return watchId;
  } else {
    const watchId = navigator.geolocation.watchPosition(
      callback,
      (error) => console.error('Watch position error:', error),
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      }
    );
    
    return watchId;
  }
};

/**
 * Clear position watch
 */
export const clearUnifiedPositionWatch = async (watchId) => {
  const isNative = Capacitor.isNativePlatform();
  
  if (isNative) {
    await Geolocation.clearWatch({ id: watchId });
  } else {
    navigator.geolocation.clearWatch(watchId);
  }
};
